import {computed, inject, Service} from '@angular/core'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {ADMIN_ROLE, READ_ONLY_ROLE, REGISTRAR_ROLE_NAME, USER_DOC_ROLE_NAME} from '../application/app'

@Service()
export class RoleHelper {

  public canShowClassic = computed(() => {
    const roles = this.userRoles()
    return roles.includes(ADMIN_ROLE) || roles.includes(READ_ONLY_ROLE)
  })

  public canShowClassicAndRegistrar = computed(() => {
    const roles = this.userRoles()
    return (roles.includes(ADMIN_ROLE) && roles.includes(REGISTRAR_ROLE_NAME))
      || (roles.includes(READ_ONLY_ROLE) && roles.includes(REGISTRAR_ROLE_NAME))
  })

  public canShowDocuments = computed(() => this.userRoles().includes(USER_DOC_ROLE_NAME))

  public canAdminClassic = computed(() => this.userRoles().includes(ADMIN_ROLE))

  public canAdminRegistrar = computed(() => this.userRoles().includes(REGISTRAR_ROLE_NAME))

  private readonly service = inject(ConfigService)

  private readonly userRoles = computed(() => this.service.currentUser()?.roles ?? [])
}